const apiConfig = {
  url: "https://mesto.nomoreparties.co/v1/cohort-54",
  headers: {
    authorization: '2ce6c808-d58b-4b11-aa87-9ee20a23a568',
    'Content-Type': 'application/json'
  },
}

export default apiConfig;